// extracted by mini-css-extract-plugin
export default {"container":"container--mp-FlWDZ","body":"body--mp-XlNgO","link":"link--mp-we9Lb"};